import React from 'react'

const ProductsCarouselComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default ProductsCarouselComponent
